export const SALESFORCE_CHAT_KEY = 'HAS_ACTIVE_SF_CHAT';
import { fetchQuery, Environment, graphql } from 'react-relay';

import { existingChatLoaded } from './trackingHelpers';

import { initSalesforceChatQuery as Query } from './__generated__/initSalesforceChatQuery.graphql';

export const initSalesforceChatQuery = graphql`
    query initSalesforceChatQuery($isSeller: Boolean!) {
        viewer {
            contact1stdibsConfig(isSeller: $isSeller) {
                chatConfig {
                    salesForceHost
                    salesForcePartnersHost
                    chatButtonId
                    chatDeploymentId
                    chatBaseLiveAgentContentUrl
                    chatLiveAgentUrl
                    salesForceOrgId
                }
            }
        }
    }
`;

export const initChat = async ({
    isSeller,
    environment,
    initiatedFromModal = false,
}: {
    isSeller: boolean;
    environment: Environment;
    initiatedFromModal?: boolean;
}): Promise<void> => {
    // if startChat function already exists on liveAgentAPI it means that embedded chat was already initiated
    if (typeof window.embedded_svc?.liveAgentAPI?.startChat === 'function') {
        return;
    }

    // after page reload, embedded_svc is not loaded instantly
    // we need to set internal to wait until embedded_svc is available
    const interval = setInterval(async () => {
        if (window.embedded_svc) {
            if (!initiatedFromModal) {
                existingChatLoaded();
            }

            const response = await fetchQuery<Query>(environment, initSalesforceChatQuery, {
                isSeller,
            });
            const chatConfig = response.viewer?.contact1stdibsConfig?.chatConfig;
            const {
                salesForceHost,
                salesForcePartnersHost,
                chatButtonId,
                chatDeploymentId,
                chatBaseLiveAgentContentUrl,
                chatLiveAgentUrl,
                salesForceOrgId,
            } = chatConfig || {};

            window.embedded_svc.settings.displayHelpButton = false;
            window.embedded_svc.settings.enabledFeatures = ['LiveAgent'];
            window.embedded_svc.settings.entryFeature = 'LiveAgent';

            window.embedded_svc.addEventHandler('onChatEndedByChasitor', () => {
                sessionStorage.removeItem(SALESFORCE_CHAT_KEY);
            });

            window.embedded_svc.addEventHandler('onChatEndedByAgent', () => {
                sessionStorage.removeItem(SALESFORCE_CHAT_KEY);
            });

            window.embedded_svc.addEventHandler('onConnectionError', () => {
                sessionStorage.removeItem(SALESFORCE_CHAT_KEY);
            });

            window.embedded_svc.init(
                salesForceHost,
                salesForcePartnersHost,
                'https://service.force.com',
                salesForceOrgId,
                // should be chaned to `isSeller ? 'Seller_Chat' : 'Buyer_Chat'`
                // once seller chat will be created on SF
                'Buyer_Chat',
                {
                    baseLiveAgentContentURL: chatBaseLiveAgentContentUrl,
                    deploymentId: chatDeploymentId,
                    buttonId: chatButtonId,
                    baseLiveAgentURL: chatLiveAgentUrl,
                    eswLiveAgentDevName: 'Live_Chat',
                    isOfflineSupportEnabled: false,
                }
            );
            clearInterval(interval);
        }
    }, 1000);
};

export default { initChat, SALESFORCE_CHAT_KEY };
